import { lazy, ReactNode } from 'react';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { PermissionGuard } from 'ui-component/common/permissionGuard';
import { RoleGuard } from 'ui-component/common/roleGuard';
import { permissions } from 'utils/permissions';
const WorkersPage = Loadable(lazy(() => import('views/workers')));
const UsersPage = Loadable(lazy(() => import('views/users')));
const ProjectsPage = Loadable(lazy(() => import('views/projects')));
const TimesheetsPage = Loadable(lazy(() => import('views/timesheets')));
const TIGsPage = Loadable(lazy(() => import('views/tigs')));
const InvoicesPage = Loadable(lazy(() => import('views/invoices')));
const KPIDashboardPage = Loadable(lazy(() => import('views/kpi')));
const TalentPoolPage = Loadable(lazy(() => import('views/talent-pool')));
const TalentCompetenciesPage = Loadable(lazy(() => import('views/talent-competencies')));
const RecruitmentPage = Loadable(lazy(() => import('views/recruitment')));
const MyDashboardRoute = Loadable(lazy(() => import('views/my-dashboard/Route')));

const guardedRoute = (requiredPermissions: string | string[], element: ReactNode) => (
  <PermissionGuard permissions={requiredPermissions} guardType="route">
    {element}
  </PermissionGuard>
);

const projectRoute = (requiredPermissions: string | string[], element: ReactNode) => (
  <RoleGuard roles={['Owner', 'Assistant', 'Subcontractor', 'SubcontractorManager']} guardType="route">
    {guardedRoute(requiredPermissions, element)}
  </RoleGuard>
);

const assistantOwnerRoute = (requiredPermissions: string | string[], element: ReactNode) => (
  <RoleGuard roles={['Owner', 'Assistant']} guardType="route">
    {guardedRoute(requiredPermissions, element)}
  </RoleGuard>
);

const kpiDashboardRoute = guardedRoute(permissions.kpi.KPI_VIEW, <KPIDashboardPage />);

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    { index: true, element: kpiDashboardRoute },
    { path: 'workers', element: guardedRoute(permissions.worker.WORKER_LIST, <WorkersPage />) },
    { path: 'users', element: guardedRoute(permissions.user.USER_LIST, <UsersPage />) },
    { path: 'projects', element: projectRoute(permissions.project.PROJECT_LIST, <ProjectsPage />) },
    { path: 'talent-pool', element: assistantOwnerRoute(permissions.talentPool.TALENT_POOL_LIST, <TalentPoolPage />) },
    { path: 'talent-competencies', element: assistantOwnerRoute(permissions.talentPool.TALENT_POOL_LIST, <TalentCompetenciesPage />) },
    {
      path: 'recruitment',
      element: (
        <RoleGuard roles={['Owner', 'Assistant']} guardType="route">
          <RecruitmentPage />
        </RoleGuard>
      )
    },
    { path: 'timesheets', element: guardedRoute(permissions.timesheet.TIMESHEET_LIST, <TimesheetsPage />) },
    { path: 'tigs', element: guardedRoute(permissions.tig.TIG_LIST, <TIGsPage />) },
    { path: 'invoices', element: guardedRoute(permissions.invoice.INVOICE_LIST, <InvoicesPage />) },
    { path: 'my-dashboard/:workerId', element: guardedRoute(permissions.worker.WORKER_READ, <MyDashboardRoute />) },
    { path: 'kpi', element: kpiDashboardRoute }
  ]
};

export default MainRoutes;
